import { FIELD_NAME_LENGTH_LIMIT } from '../../../query/types.ts'
import { makeIdentifiable } from '../../../util/makeIdentifiable.ts'

export function generateFieldName({ nodeName, propertyName }: { nodeName: string; propertyName: string }) {
  return makeIdentifiable([nodeName, propertyName].join('_'), FIELD_NAME_LENGTH_LIMIT)
}
